import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import viewStyles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { Link, useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import { getBankAccounts } from "../../../../redux/features/bank/bankService";
import { getAllCountries } from "../../../../redux/features/countries/countriesService";
import { getAllMakes } from "../../../../redux/features/makes/makesService";
import { getModelByMakeId } from "../../../../redux/features/models/modelsService";
import { getModelCodesByModelId } from "../../../../redux/features/modelCodes/modelCodesService";
import YearsDropdown from "../../../../components/YearsDropdown/YearsDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faRefresh } from "@fortawesome/free-solid-svg-icons";
import ClipLoader from "react-spinners/ClipLoader";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import {
  editQuickInvoice,
  getQuickInvoiceByStaffById,
  saveQuickInvoiceDocument,
} from "../../../../redux/features/quickInvoice/quickInvoiceService";
import { selectUserDetails } from "../../../../redux/features/auth/authSlice";
import { NumericFormat } from "react-number-format";
import QRCode from "qrcode";
import EditQuickInvoicePdf from "../../../../components/Receipts/EditQuickInvoicePdf";
import { editInvoiceVehicle } from "../../../../redux/features/vehicleInvoice/vehicleInvoiceService";
import { Calendar, CarFront, Cog, Edit, Receipt, Trash2 } from "lucide-react";

const MONTHS = [
  { id: 1, name: "01" },
  { id: 2, name: "02" },
  { id: 3, name: "03" },
  { id: 4, name: "04" },
  { id: 5, name: "05" },
  { id: 6, name: "06" },
  { id: 7, name: "07" },
  { id: 8, name: "08" },
  { id: 9, name: "09" },
  { id: 10, name: "10" },
  { id: 11, name: "11" },
  { id: 12, name: "12" },
];

function getMonthOptions(selectedYear) {
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();

  if (selectedYear == currentYear) {
    return MONTHS.slice(0, currentMonthIndex + 1).reverse();
  }

  return MONTHS;
}
const EditQuickInvoice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const countryDropdownRef = useRef(null);
  const makesDropdownRef = useRef(null);
  const modelsDropdownRef = useRef(null);

  const { details } = useSelector(selectUserDetails);
  const { isVehicleCreating } = useSelector(
    (state) => state.vehicle.newVehicle
  );
  const { isCountriesLoading, countries } = useSelector(
    (state) => state.country.allCountries
  );
  const { isMakesLoading, makes } = useSelector((state) => state.make.allMakes);
  const { isModelsByMakeLoading, modelsByMake } = useSelector(
    (state) => state.model.allModelsByMakeId
  );

  const [selectedMake, setSelectedMake] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [vehicleFormData, setVehicleFormData] = useState({});

  const [vehicleErrorMessages, setVehicleErrorMessages] = useState({});
  const [disabledBtn, setBtnDisable] = useState(false);

  const [vehicles, setVehicles] = useState([]);
  const [qrLink, setQrLink] = useState(null);

  const [formData, setFormData] = useState({});
  const [selectedBank, setSelectedBank] = useState(null);

  const [removedVehicles, setRemovedVehicles] = useState([]);
  const [isEdit, setEdit] = useState(false);
  const [isHSCode, setHSCode] = useState(false);

  //fetch data
  const fetchCountries = useCallback(
    (filters = {}) => {
      const params = {
        status: true,
        ...filters,
      };
      dispatch(getAllCountries(params));
    },
    [dispatch]
  );

  const fetchMakes = useCallback(
    (filters = {}) => {
      const params = {
        status: true,
        ...filters,
      };
      dispatch(getAllMakes(params));
    },
    [dispatch]
  );

  const fetchInvoice = async () => {
    try {
      const response = await dispatch(
        getQuickInvoiceByStaffById({ id: id })
      ).unwrap();
      setFormData(response);
      setVehicles(response?.vehicle_for_invoices);
      setSelectedBank(response?.bank_account);
      setRemovedVehicles([]);
    } catch (error) {
      showToast("error", "Unable to fetch the invoice");
    }
  };

  const fetchModels = async (makeId) => {
    await dispatch(getModelByMakeId({ makeId: makeId })).unwrap();
  };

  const fetchModelCodes = async (modelId) => {
    await dispatch(getModelCodesByModelId({ modelId: modelId })).unwrap();
  };

  useEffect(() => {
    fetchInvoice();
    fetchCountries();
    fetchMakes();
  }, [fetchCountries, fetchMakes]);

  const handleSelect = (option) => {
    setVehicleFormData({
      ...vehicleFormData,
      countryId: option.id,
      countryName: option.name,
    });
    setVehicleErrorMessages({ ...vehicleErrorMessages, countryId: "" });
    setSelectedCountry({
      id: option.id,
      name: option.name,
    });
  };

  const handleMakeSelect = (option) => {
    setVehicleFormData({
      ...vehicleFormData,
      makeId: option.id,
      makeName: option.name,
      hs_code: "",
    });
    setVehicleErrorMessages({ ...vehicleErrorMessages, makeId: "" });
    setSelectedModel(null);
    setHSCode(false);
    fetchModels(option.id);
    setSelectedMake({
      id: option.id,
      name: option.name,
    });
  };

  const handleModelSelect = (option) => {
    setVehicleFormData({
      ...vehicleFormData,
      modelId: option.id,
      modelName: option.name,
      hs_code: option.hs_code ? option.hs_code : "",
    });
    if (option?.hs_code) {
      setHSCode(true);
    } else {
      setHSCode(false);
    }
    setVehicleErrorMessages({ ...vehicleErrorMessages, modelId: "" });
    fetchModelCodes(option.id);
    setSelectedModel({
      id: option.id,
      name: option.name,
    });
  };

  const handleVehicleInputChange = (e) => {
    const { name, value } = e.target;

    setVehicleFormData((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      // Calculate total_price from updated values
      updated.total_price =
        (Number(updated.fob_cost) || 0) +
        (Number(updated.freight) || 0) +
        (Number(updated.insurance) || 0);

      return updated;
    });

    setVehicleErrorMessages((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleMfgYearChange = (selectedMonth) => {
    setVehicleFormData((prev) => ({ ...prev, mfg_year: selectedMonth.name }));
    setVehicleErrorMessages({ ...vehicleErrorMessages, mfg_year: "" });
  };

  const onChangeMonth = (selectedMonth) => {
    setVehicleFormData((prev) => ({ ...prev, mfg_month: selectedMonth.name }));
  };

  // Validate input
  const isValidVehicle = () => {
    const errors = {};
    if (!vehicleFormData.chassis_no) {
      errors.chassis_no = "Chassis Number is required.";
    }
    if (!vehicleFormData.engine_capacity) {
      errors.engine_capacity = "Engine Capacity is required.";
    }
    if (!vehicleFormData.mfg_year) {
      errors.mfg_year = "Manufacturing Year is required.";
    }
    if (!vehicleFormData.fob_cost) {
      errors.fob_cost = "FOB Cost is required.";
    }
    if (!vehicleFormData.freight) {
      errors.freight = "Freight is required.";
    }
    if (!vehicleFormData.insurance) {
      errors.insurance = "Insurance is required.";
    }
    if (!vehicleFormData.countryId) {
      errors.countryId = "Country is required.";
    }
    if (!vehicleFormData.makeId) errors.makeId = "Make is required.";
    if (!vehicleFormData.modelId) errors.modelId = "Model is required.";

    if (Object.keys(errors).length > 0) {
      setVehicleErrorMessages(errors);
      return false;
    } else {
      return true;
    }
  };

  const resetAllSelections = () => {
    setSelectedMake(null);
    setSelectedModel(null);
    setSelectedCountry(null);
  };

  const updateTheVehicle = async (formData) => {
    try {
      const response = await dispatch(editInvoiceVehicle(formData)).unwrap();
      showToast("success", response.message);
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const insertNewVehicle = async () => {
    if (!isValidVehicle()) return;

    let isUpdate = false;
    let updatedList = [];

    setVehicles((prevVehicles) => {
      const existingIndex = prevVehicles.findIndex(
        (v) => v.id === vehicleFormData.id
      );

      if (existingIndex !== -1) {
        // Update existing vehicle
        isUpdate = true;
        updatedList = [...prevVehicles];
        updatedList[existingIndex] = {
          ...updatedList[existingIndex],
          ...vehicleFormData,
        };
        return updatedList;
      } else {
        const exists = prevVehicles.some(
          (v) => v.chassis_no === vehicleFormData.chassis_no
        );
        if (exists) return prevVehicles;

        updatedList = [...prevVehicles, vehicleFormData];
        return updatedList;
      }
    });
    if (isUpdate) {
      const data = {
        id: vehicleFormData?.id,
        chassis_no: vehicleFormData?.chassis_no,
        engine_capacity: vehicleFormData?.engine_capacity,
        mfg_year: vehicleFormData?.mfg_year,
        mfg_month: vehicleFormData?.mfg_month,
        country: selectedCountry,
        make: selectedMake,
        model: selectedModel,
        hs_code: vehicleFormData?.hs_code,
        fob_cost: vehicleFormData?.fob_cost,
        freight: vehicleFormData?.freight,
        insurance: vehicleFormData?.insurance,
        total_price: vehicleFormData?.total_price,
      };
      setEdit(false);
      await updateTheVehicle(data);
    }

    resetAllSelections();
    setVehicleFormData({
      id: "",
      chassis_no: "",
      engine_capacity: "",
      hs_code: "",
      fob_cost: "",
      freight: "",
      insurance: "",
      total_price: "",
    });
  };

  const removeVehicle = (chassis_no) => {
    setVehicles((prevVehicles) => {
      const vehicleToRemove = prevVehicles.find(
        (v) => v.chassis_no === chassis_no
      );

      if (vehicleToRemove) {
        // add to removedVehicles
        setRemovedVehicles((prev) => [...prev, vehicleToRemove]);
      }

      return prevVehicles.filter((v) => v.chassis_no !== chassis_no);
    });
  };

  // Invoice
  const { isInvoiceLoading } = useSelector(
    (state) => state.quickInvoice.quickInvoiceDetails
  );
  const { isBankAccountsLoading, bankAccounts } = useSelector(
    (state) => state.bank.allBankAccounts
  );

  const [errorMessages, setErrorMessages] = useState({});
  const [isNotifyParty, setNotifyParty] = useState(false);

  useEffect(() => {
    dispatch(getBankAccounts({}));
  }, [dispatch]);

  useEffect(() => {
    // Step 2: Generate QR once certificate is available
    const generateQR = async () => {
      try {
        const qrDataUrl = await QRCode.toDataURL(
          `https://wa.me/message/QZINMGG3OZFHK1`,
          { width: 70 } // adjust QR size
        );
        setQrLink(qrDataUrl);
      } catch (err) {
        console.error("QR code generation failed:", err);
      }
    };

    generateQR();
  }, []);

  
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updatedData = {
        ...prev,
        [name]: value,
      };

      // ✅ Sync notify_name with bill_to_name (only if not manually changed)
      if (name === "bill_to_name") {
        if (
          !prev.notify_name ||
          prev.notify_name === prev.bill_to_name
        ) {
          updatedData.notify_name = value;
        }
      }

      if (name === "bill_to_email") {
        if (
          !prev.notify_to_email ||
          prev.notify_to_email === prev.bill_to_email
        ) {
          updatedData.notify_to_email = value;
        }
      }

      if (name === "bill_to_phone_number") {
        if (
          !prev.notify_to_phone_number ||
          prev.notify_to_phone_number === prev.bill_to_phone_number
        ) {
          updatedData.notify_to_phone_number = value;
        }
      }

        if (name === "address_line_1") {
        if (
          !prev.notify_address_line_1 ||
          prev.notify_address_line_1 === prev.address_line_1
        ) {
          updatedData.notify_address_line_1 = value;
        }
      }

       if (name === "address_line_2") {
        if (
          !prev.notify_address_line_2 ||
          prev.notify_address_line_2 === prev.address_line_2
        ) {
          updatedData.notify_address_line_2 = value;
        }
      }

      return updatedData;
    });

    setErrorMessages((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Validate input
  const isValidQuotation = () => {
    const errors = {};
    if (!formData.address_line_1) {
      errors.address_line_1 = "Address line one is required.";
    }
    if (!formData.address_line_2) {
      errors.address_line_2 = "Address line two is required.";
    }
    if (!formData.city) {
      errors.city = "City is required.";
    }
    if (!formData.invoice_date) {
      errors.invoice_date = "Date is required.";
    }
    if (!formData.invoice_type) {
      errors.invoice_type = "Invoice Type is required.";
    }
    if (!formData.total_price_type) {
      errors.total_price_type = "Price type is required.";
    }
    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return false;
    } else {
      return true;
    }
  };

  const data = {
    order_id: 1,
    bill_to_name: "Nimal Perera",
    bill_to_address: "No 12, Main Road",
    city: "Colombo",
    details_line_1: "Sri Lanka",
    invoice_date: "2025-05-24",
    valid_until: "2025-06-24",
    notes: "",
    quotation_status: "Quotation_Created",
  };

  const generateInvoice = async (data, invoice) => {
    try {
        const uuid = crypto.randomUUID();
             const qrDataUrl = await QRCode.toDataURL(
              `https://cdn.jandatrade.com/invoice_document_file/${uuid}`,
              {
                width: 70,              // bigger = clearer
                margin: 2,
                errorCorrectionLevel: "L"
              } // adjust QR size
            );
      const pdfBlob = await pdf(
        <EditQuickInvoicePdf
          data={[
            data,
            invoice?.vehicle_for_invoices,
            selectedBank,
            details,
            invoice,
            qrDataUrl,
          ]}
        />
      ).toBlob();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
      dispatch(
        saveQuickInvoiceDocument({
          invoice_document_file: pdfBlob,
          invoice_id: id,
          invoice_document_id: uuid
        })
      );
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const [isInvoiceCreating, setInvoiceCreating] = useState(false);

  const submitQuotation = async () => {
    if (isValidQuotation()) {
      setInvoiceCreating(true);
      const vehicle_from_invoice = [];
      const createVehicleForInvoiceDtos = [];
      const vehicle_for_invoices = [];

      vehicles.forEach((v) => {
        if (v.id) {
          vehicle_from_invoice.push(Number(v.id));
        } else {
          createVehicleForInvoiceDtos.push(v);
        }
      });
      removedVehicles.forEach((v) => {
        if (v.id) {
          vehicle_for_invoices.push(Number(v.id));
        }
      });

      const data = {
        invoice_id: id,
        bank_account_id: +selectedBank.id,
        bill_to_name: formData.bill_to_name,
        bill_to_email: formData.bill_to_email,
        bill_to_phone_number: formData.bill_to_phone_number,
        address_line_1: formData.address_line_1,
        address_line_2: formData.address_line_2,
        city: formData.city,
        notify_name:
          formData.notify_name != null
            ? formData.notify_name
            : formData.bill_to_name,
        notify_to_email:
          formData.notify_to_email != null
            ? formData.notify_to_email
            : formData.bill_to_email,
        notify_to_phone_number:
          formData.notify_to_phone_number != null
            ? formData.notify_to_phone_number
            : formData.bill_to_phone_number,
        notify_address_line_1:
          formData.notify_address_line_1 != null
            ? formData.notify_address_line_1
            : formData.address_line_1,
        notify_address_line_2:
          formData.notify_address_line_2 != null
            ? formData.notify_address_line_2
            : formData.address_line_2,
        notifY_city:
          formData.notify_country != null
            ? formData.notify_country
            : formData.city,
        invoice_date: formData.invoice_date,
        notes: formData.notes && formData.notes,
        shipping_marks: formData && formData.shipping_marks,
        shipment_type: formData.shipment_type && formData.shipment_type,
        incoterm: formData.incoterm && formData.incoterm,
        country: formData.country,
        port_loading: formData.port_loading && formData.port_loading,
        port_unloading: formData.port_unloading && formData.port_unloading,
        destination: formData.destination && formData.destination,
        currency: formData.currency && formData.currency,
        shipment_date: formData.shipment_date && formData.shipment_date,
        lc_validity_period:
          formData.lc_validity_period && formData.lc_validity_period,
        transhipment: formData.transhipment && formData.transhipment,
        partial_shipment:
          formData.partial_shipment && formData.partial_shipment,
        total_price_type: formData.total_price_type,
        invoice_type: formData.invoice_type,
        createVehicleForInvoiceDtos: createVehicleForInvoiceDtos,
        vehicle_for_invoices: vehicle_for_invoices,
        invoice_status: "Invoice Created",
      };
      const pdfData = {
        invoice_no: formData?.invoice_no,
        bank_account_id: +selectedBank.id,
        bill_to_name: formData.bill_to_name,
        bill_to_email: formData.bill_to_email,
        bill_to_phone_number: formData.bill_to_phone_number,
        address_line_1: formData.address_line_1,
        address_line_2: formData.address_line_2,
        city: formData.city,
        notify_name:
          formData.notify_name != null
            ? formData.notify_name
            : formData.bill_to_name,
        notify_to_email:
          formData.notify_to_email != null
            ? formData.notify_to_email
            : formData.bill_to_email,
        notify_to_phone_number:
          formData.notify_to_phone_number != null
            ? formData.notify_to_phone_number
            : formData.bill_to_phone_number,
        notify_address_line_1:
          formData.notify_address_line_1 != null
            ? formData.notify_address_line_1
            : formData.address_line_1,
        notify_address_line_2:
          formData.notify_address_line_2 != null
            ? formData.notify_address_line_2
            : formData.address_line_2,
        notifY_city:
          formData.notify_country != null
            ? formData.notify_country
            : formData.city,
        invoice_date: formData.invoice_date,
        notes: formData.notes && formData.notes,
        shipping_marks: formData && formData.shipping_marks,
        shipment_type: formData.shipment_type && formData.shipment_type,
        incoterm: formData.incoterm && formData.incoterm,
        country: formData.country,
        port_loading: formData.port_loading && formData.port_loading,
        port_unloading: formData.port_unloading && formData.port_unloading,
        destination: formData.destination && formData.destination,
        currency: formData.currency && formData.currency,
        shipment_date: formData.shipment_date && formData.shipment_date,
        lc_validity_period:
          formData.lc_validity_period && formData.lc_validity_period,
        transhipment: formData.transhipment && formData.transhipment,
        partial_shipment:
          formData.partial_shipment && formData.partial_shipment,
        total_price_type: formData.total_price_type,
        invoice_type: formData.invoice_type,
        createVehicleForInvoiceDtos: vehicles,
        invoice_status: "Invoice Created",
        isNotifyParty: true,
      };
      try {
        const response = await dispatch(editQuickInvoice(data)).unwrap();
        showToast("success", response.message);
        await generateInvoice(pdfData, response?.quick_invoice);
        setInvoiceCreating(false);
        navigate("/specialist/quick-invoices");
      } catch (error) {
        showToast("error", error.message);
        setInvoiceCreating(false);
      }
    }
  };

  const viewInvoice = (document) => {
    window.open(document.invoice_document, "_blank");
  };

  return (
    <div className={`card-section`}>
      <div className={`main-card`}>
        <h1 className={`form-title`}>
          {isEdit ? `Edit Vehicle` : `Add New Vehicle`}
        </h1>
        <div className={styles.formContainer}>
          <form className={styles.coordinatorForm} noValidate>
            <div className={styles.vehicleFormGroup}>
              <div className={`form-input-row`}>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Chassis Number
                    </label>
                    <input
                      type="text"
                      id="chassis_no"
                      name="chassis_no"
                      value={vehicleFormData.chassis_no}
                      onChange={handleVehicleInputChange}
                      placeholder="Enter Chassis Number"
                      className={`form-input-default`}
                    />
                    {vehicleErrorMessages.chassis_no && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.chassis_no}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Engine Capacity (cc)
                    </label>
                    <input
                      type="text"
                      id="engine_capacity"
                      name="engine_capacity"
                      value={vehicleFormData.engine_capacity}
                      onChange={handleVehicleInputChange}
                      placeholder="Enter Engine Capacity"
                      className={`form-input-default`}
                    />
                    {vehicleErrorMessages.engine_capacity && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.engine_capacity}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`form-input-row`}>
                <div className={`form-input-col sm-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Mfg. Year
                    </label>
                    <YearsDropdown
                      onChange={handleMfgYearChange}
                      value={vehicleFormData.mfg_year}
                    />
                    {vehicleErrorMessages.mfg_year && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.mfg_year}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col sm-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Mfg. Month
                    </label>
                    <Dropdown
                      options={getMonthOptions(vehicleFormData.mfg_year)}
                      placeholder="Select a Month"
                      value={vehicleFormData.mfg_month}
                      onSelect={onChangeMonth}
                    />
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Country
                      <Link
                        to="/admin/countries"
                        target="_blank"
                        style={{
                          cursor: "pointer",
                          color: "black",
                          marginLeft: "5px",
                          marginRight: "5px",
                        }}
                      >
                        <FontAwesomeIcon icon={faPlusCircle} />
                      </Link>
                      {isCountriesLoading ? (
                        <ClipLoader size={15} />
                      ) : (
                        <FontAwesomeIcon
                          icon={faRefresh}
                          onClick={fetchCountries}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </label>
                    <Dropdown
                      ref={countryDropdownRef}
                      options={countries}
                      placeholder="Choose an Option"
                      onSelect={handleSelect}
                      value={selectedCountry?.name}
                    />
                    {vehicleErrorMessages.countryId && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.countryId}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`form-input-row`}>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Make
                      <Link
                        to="/admin/makes"
                        target="_blank"
                        style={{
                          cursor: "pointer",
                          color: "black",
                          marginLeft: "5px",
                          marginRight: "5px",
                        }}
                      >
                        <FontAwesomeIcon icon={faPlusCircle} />
                      </Link>
                      {isMakesLoading ? (
                        <ClipLoader size={15} />
                      ) : (
                        <FontAwesomeIcon
                          icon={faRefresh}
                          onClick={fetchMakes}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </label>
                    <Dropdown
                      ref={makesDropdownRef}
                      options={makes}
                      placeholder="Choose an Option"
                      onSelect={handleMakeSelect}
                      value={selectedMake?.name}
                    />
                    {vehicleErrorMessages.makeId && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.makeId}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col sm-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Model
                      <Link
                        to="/admin/models"
                        target="_blank"
                        style={{
                          cursor: "pointer",
                          color: "black",
                          marginLeft: "5px",
                          marginRight: "5px",
                        }}
                      >
                        <FontAwesomeIcon icon={faPlusCircle} />
                      </Link>
                      {selectedMake &&
                      selectedMake.id !== null &&
                      isModelsByMakeLoading ? (
                        <ClipLoader size={15} />
                      ) : (
                        <FontAwesomeIcon
                          icon={faRefresh}
                          onClick={() =>
                            selectedMake && fetchModels(selectedMake.id)
                          }
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </label>
                    <Dropdown
                      ref={modelsDropdownRef}
                      options={modelsByMake}
                      placeholder="Choose an Option"
                      onSelect={handleModelSelect}
                      value={selectedModel?.name}
                    />
                    {vehicleErrorMessages.modelId && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.modelId}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      HS Code
                    </label>
                    <input
                      type="text"
                      id="hs_code"
                      name="hs_code"
                      value={vehicleFormData.hs_code}
                      onChange={handleVehicleInputChange}
                      placeholder="Enter HS Code"
                      className={`form-input-default`}
                      disabled={isHSCode}
                    />
                    {vehicleErrorMessages.hs_code && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.hs_code}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`form-input-row`}>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      FOB Cost
                    </label>
                    {/* <input
                                            type='text'
                                            id='fob_cost'
                                            name='fob_cost'
                                            value={vehicleFormData.fob_cost}
                                            onChange={handleVehicleInputChange}
                                            placeholder='Enter FOB Cost'
                                            className={`form-input-default`}
                                        /> */}
                    <NumericFormat
                      id="fob_cost"
                      name="fob_cost"
                      value={vehicleFormData["fob_cost"]}
                      thousandSeparator=","
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={false}
                      placeholder="Enter FOB Cost"
                      className={`form-input-default`}
                      onValueChange={(values) => {
                        const { value } = values; // unformatted value
                        handleVehicleInputChange({
                          target: {
                            name: "fob_cost",
                            value: value,
                          },
                        });
                      }}
                    />
                    {vehicleErrorMessages.fob_cost && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.fob_cost}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Freight
                    </label>
                    <NumericFormat
                      id="freight"
                      name="freight"
                      value={vehicleFormData["freight"]}
                      thousandSeparator=","
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={false}
                      placeholder="Enter Freight"
                      className={`form-input-default`}
                      onValueChange={(values) => {
                        const { value } = values;
                        handleVehicleInputChange({
                          target: {
                            name: "freight",
                            value: value,
                          },
                        });
                      }}
                    />
                    {vehicleErrorMessages.freight && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.freight}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Insurance
                    </label>
                    <NumericFormat
                      id="insurance"
                      name="insurance"
                      value={vehicleFormData["insurance"]}
                      thousandSeparator=","
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={false}
                      placeholder="Enter Insurance"
                      className={`form-input-default`}
                      onValueChange={(values) => {
                        const { value } = values; // unformatted value
                        handleVehicleInputChange({
                          target: {
                            name: "insurance",
                            value: value,
                          },
                        });
                      }}
                    />
                    {vehicleErrorMessages.insurance && (
                      <p className={`text-danger`}>
                        {vehicleErrorMessages.insurance}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col sm-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor="full_name" className={`form-label`}>
                      Total Price
                    </label>
                    <NumericFormat
                      id="total_price"
                      name="total_price"
                      value={vehicleFormData["total_price"]}
                      thousandSeparator=","
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={false}
                      placeholder="Total Price"
                      className={`form-input-default`}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <button
              className={`btn-primary`}
              type="button"
              disabled={disabledBtn}
              onClick={insertNewVehicle}
            >
              {isVehicleCreating ? (
                <BeatLoader color="#ffffff" />
              ) : isEdit ? (
                `Edit`
              ) : (
                `Add`
              )}
            </button>
          </form>
        </div>
        <div className="quick-invoice-vehicle-grid">
          {vehicles?.length > 0 &&
            vehicles?.map((vehicle, index) => (
              <div key={vehicle.id} className="quick-invoice-vehicle-card">
                <div className="card-header">
                  <div>
                    <div className="quick-invoice-vehicle-id">
                      Engine: {vehicle?.engine_capacity} cc
                    </div>
                    <h2 className="quick-invoice-vehicle-name">
                      Chassis No: {vehicle?.chassis_no}
                    </h2>
                  </div>
                  <span>
                    <img
                      src={
                        makes?.find((m) => m.id === vehicle?.makeId)
                          ?.image_url || vehicle?.make?.image_url
                      }
                      alt={
                        vehicle?.make?.name ||
                        makes?.find((m) => m.id === vehicle?.make_id)?.name ||
                        "Make"
                      }
                      className="quick-invoice-vehicle-make-logo"
                    />
                  </span>
                </div>
                <div className="quick-invoice-vehicle-details">
                  <div className="detail-row">
                    <CarFront size={16} className="role-icon" />
                    <span className="main-text">
                      {makes?.find((m) => m.id === vehicle?.makeId)?.name ||
                        vehicle?.make?.name}
                    </span>
                  </div>
                  <div className="detail-row">
                    <Cog size={16} />
                    <span>
                      {modelsByMake?.find((m) => m.id === vehicle?.modelId)
                        ?.name || vehicle?.model?.name}
                    </span>
                  </div>
                  <div className="detail-row">
                    <Calendar size={16} />
                    <span>{vehicle?.mfg_year}{(vehicle?.mfg_month !== null && vehicle?.mfg_month !== 0) && '-'}{(vehicle?.mfg_month !== null && vehicle?.mfg_month !== 0) && vehicle?.mfg_month}</span>
                  </div>
                  <div className="detail-row patient-count-section">
                    <Receipt size={16} className="patient-icon" />
                    <span style={{ marginRight: "0.5rem" }}>Total Price:</span>
                    <span className="patient-count">
                      {" "}
                      {Number(vehicle?.total_price || 0).toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </span>
                  </div>
                </div>
                <div className="card-actions">
                  {vehicle.id ? (
                    <button
                      onClick={() => {
                        setVehicleFormData({
                          id: vehicle?.id,
                          chassis_no: vehicle?.chassis_no,
                          engine_capacity: vehicle?.engine_capacity,
                          mfg_year: vehicle?.mfg_year,
                          mfg_month: vehicle?.mfg_month,
                          fob_cost: vehicle?.fob_cost,
                          freight: vehicle?.freight,
                          insurance: vehicle?.insurance,
                          hs_code: vehicle?.hs_code,
                          countryId: vehicle?.country?.id,
                          makeId: vehicle?.make?.id,
                          modelId: vehicle?.model?.id,
                        });
                        setSelectedCountry(vehicle?.country);
                        setSelectedMake(vehicle?.make);
                        setSelectedModel(vehicle?.model);
                        setEdit(true);
                        setVehicleErrorMessages({});
                      }}
                      title="Edit quick-invoice-vehicle"
                      className="card-action-button action-edit"
                    >
                      <Edit size={16} />
                      Edit
                    </button>
                  ) : (
                    <button className="card-action-button" disabled>
                      New
                    </button>
                  )}
                  <button
                    onClick={() => removeVehicle(vehicle?.chassis_no)}
                    title="Delete quick-invoice-vehicle"
                    className="card-action-button action-delete"
                  >
                    <Trash2 size={16} />
                    Delete
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div
        className={`main-card`}
        style={{
          minHeight: "max-content",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h1 className={`form-title`}>Invoice</h1>
        <div className={styles.formContainer}>
          {/* Invoices */}
          <div className={styles.vehicleFormGroup}>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Bill to Name<span className={`required-star`}>*</span>
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="bill_to_name"
                      name="bill_to_name"
                      value={formData.bill_to_name || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Name"
                    />
                  )}
                  {errorMessages.bill_to_name && (
                    <p className={`text-danger`}>
                      {errorMessages.bill_to_name}
                    </p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Billing Email
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="bill_to_email"
                      name="bill_to_email"
                      value={formData.bill_to_email || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Email"
                    />
                  )}
                  {errorMessages.bill_to_email && (
                    <p className={`text-danger`}>
                      {errorMessages.bill_to_email}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Bill to Phone Number
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="bill_to_phone_number"
                      name="bill_to_phone_number"
                      value={formData.bill_to_phone_number || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Phone Number"
                    />
                  )}
                  {errorMessages.bill_to_phone_number && (
                    <p className={`text-danger`}>
                      {errorMessages.bill_to_phone_number}
                    </p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Billing Address Line 1
                      <span className={`required-star`}>*</span>
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="address_line_1"
                      name="address_line_1"
                      value={formData.address_line_1 || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Address"
                    />
                  )}
                  {errorMessages.address_line_1 && (
                    <p className={`text-danger`}>
                      {errorMessages.address_line_1}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Billing Address Line 2
                      <span className={`required-star`}>*</span>
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="address_line_2"
                      name="address_line_2"
                      value={formData.address_line_2 || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Address"
                    />
                  )}
                  {errorMessages.address_line_2 && (
                    <p className={`text-danger`}>
                      {errorMessages.address_line_2}
                    </p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      City & Country<span className={`required-star`}>*</span>
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={formData.city || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Address"
                    />
                  )}
                  {errorMessages.city && (
                    <p className={`text-danger`}>{errorMessages.city}</p>
                  )}
                </div>
              </div>
            </div>
            {/* Notify */}
            <>
              <p>Notify Party Details</p>
              <div className={`form-input-row`}>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <label htmlFor="full_name" className={`form-label`}>
                        Notify Name
                      </label>
                    )}
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <input
                        type="text"
                        id="notify_name"
                        name="notify_name"
                        value={
                          formData?.notify_name
                            ? formData?.notify_name
                            : formData?.bill_to_name || ""
                        }
                        onChange={handleInputChange}
                        className={`form-input-default`}
                        placeholder="Enter Address"
                      />
                    )}
                    {errorMessages.notify_name && (
                      <p className={`text-danger`}>
                        {errorMessages.notify_name}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <label htmlFor="full_name" className={`form-label`}>
                        Notify Email
                      </label>
                    )}
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <input
                        type="text"
                        id="notify_to_email"
                        name="notify_to_email"
                        value={
                          formData?.notify_to_email
                            ? formData?.notify_to_email
                            : formData?.bill_to_email || ""
                        }
                        onChange={handleInputChange}
                        className={`form-input-default`}
                        placeholder="Enter Email"
                      />
                    )}
                    {errorMessages.notify_to_email && (
                      <p className={`text-danger`}>
                        {errorMessages.notify_to_email}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`form-input-row`}>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <label htmlFor="full_name" className={`form-label`}>
                        Notify Phone Number
                      </label>
                    )}
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <input
                        type="text"
                        id="notify_to_phone_number"
                        name="notify_to_phone_number"
                        value={
                          formData?.notify_to_phone_number
                            ? formData?.notify_to_phone_number
                            : formData?.bill_to_phone_number || ""
                        }
                        onChange={handleInputChange}
                        className={`form-input-default`}
                        placeholder="Enter Phone Number"
                      />
                    )}
                    {errorMessages.notify_to_phone_number && (
                      <p className={`text-danger`}>
                        {errorMessages.notify_to_phone_number}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <label htmlFor="full_name" className={`form-label`}>
                        Notify Billing Address Line 1
                      </label>
                    )}
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <input
                        type="text"
                        id="notify_address_line_1"
                        name="notify_address_line_1"
                        value={
                          formData?.notify_address_line_1
                            ? formData?.notify_address_line_1
                            : formData?.address_line_1 || ""
                        }
                        onChange={handleInputChange}
                        className={`form-input-default`}
                        placeholder="Enter Address"
                      />
                    )}
                    {errorMessages.notify_address_line_1 && (
                      <p className={`text-danger`}>
                        {errorMessages.notify_address_line_1}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className={`form-input-row`}>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <label htmlFor="full_name" className={`form-label`}>
                        Notify Billing Address Line 2
                      </label>
                    )}
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <input
                        type="text"
                        id="notify_address_line_2"
                        name="notify_address_line_2"
                        value={
                          formData?.notify_address_line_2
                            ? formData?.notify_address_line_2
                            : formData?.address_line_2 || ""
                        }
                        onChange={handleInputChange}
                        className={`form-input-default`}
                        placeholder="Enter Address"
                      />
                    )}
                    {errorMessages.notifY_city && (
                      <p className={`text-danger`}>
                        {errorMessages.notifY_city}
                      </p>
                    )}
                  </div>
                </div>
                <div className={`form-input-col md-col`}>
                  <div className={`form-input-group`}>
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <label htmlFor="full_name" className={`form-label`}>
                        Notify City & Country
                      </label>
                    )}
                    {isInvoiceLoading ? (
                      <Skeleton />
                    ) : (
                      <input
                        type="text"
                        id="notify_city"
                        name="notify_city"
                        value={
                          formData?.notifY_city
                            ? formData?.notifY_city
                            : formData?.city || ""
                        }
                        onChange={handleInputChange}
                        className={`form-input-default`}
                        placeholder="Enter Country"
                      />
                    )}
                    {errorMessages.notify_city && (
                      <p className={`text-danger`}>
                        {errorMessages.notify_city}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Invoice Date<span className={`required-star`}>*</span>
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="date"
                      id="invoice_date"
                      name="invoice_date"
                      value={formData.invoice_date || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                    />
                  )}
                  {errorMessages.invoice_date && (
                    <p className={`text-danger`}>
                      {errorMessages.invoice_date}
                    </p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Shipment Type
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="shipment_type"
                      name="shipment_type"
                      value={formData.shipment_type || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Shipment Type"
                    />
                  )}
                  {errorMessages.shipment_type && (
                    <p className={`text-danger`}>
                      {errorMessages.shipment_type}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Incoterm
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="incoterm"
                      name="incoterm"
                      value={formData.incoterm || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Incoterm"
                    />
                  )}
                  {errorMessages.incoterm && (
                    <p className={`text-danger`}>{errorMessages.incoterm}</p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Country
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="country"
                      name="country"
                      value={formData.country || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Country"
                    />
                  )}
                  {errorMessages.country && (
                    <p className={`text-danger`}>{errorMessages.country}</p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Port of Loading
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="port_loading"
                      name="port_loading"
                      value={formData.port_loading || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Port of Loading"
                    />
                  )}
                  {errorMessages.port_loading && (
                    <p className={`text-danger`}>
                      {errorMessages.port_loading}
                    </p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Port of Unloading
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="port_unloading"
                      name="port_unloading"
                      value={formData.port_unloading || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Port of Unoading"
                    />
                  )}
                  {errorMessages.port_unloading && (
                    <p className={`text-danger`}>
                      {errorMessages.port_unloading}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Final Destination
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="destination"
                      name="destination"
                      value={formData.destination || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Final Destination"
                    />
                  )}
                  {errorMessages.destination && (
                    <p className={`text-danger`}>{errorMessages.destination}</p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Currency
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="text"
                      id="currency"
                      name="currency"
                      value={formData.currency || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                      placeholder="Enter Currency"
                    />
                  )}
                  {errorMessages.currency && (
                    <p className={`text-danger`}>{errorMessages.currency}</p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Payment Terms
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <textarea
                      type="text"
                      id="notes"
                      name="notes"
                      value={formData.notes || ""}
                      onChange={handleInputChange}
                      placeholder="Enter Payment Terms"
                      className={`form-input-default`}
                    />
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Shipping Marks
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <textarea
                      type="text"
                      id="shipping_marks"
                      name="shipping_marks"
                      value={formData.shipping_marks || ""}
                      onChange={handleInputChange}
                      placeholder="Enter Shipping Marks"
                      className={`form-input-default`}
                    />
                  )}
                </div>
              </div>
            </div>
            {/* Terms */}
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <label htmlFor="full_name" className={`form-label`}>
                      Shipment Date
                    </label>
                  )}
                  {isInvoiceLoading ? (
                    <Skeleton />
                  ) : (
                    <input
                      type="date"
                      id="shipment_date"
                      name="shipment_date"
                      value={formData.shipment_date || ""}
                      onChange={handleInputChange}
                      className={`form-input-default`}
                    />
                  )}
                  {errorMessages.shipment_date && (
                    <p className={`text-danger`}>
                      {errorMessages.shipment_date}
                    </p>
                  )}
                </div>
              </div>
              <div className={`form-input-col md-col`}>
                {isInvoiceLoading ? (
                  <Skeleton />
                ) : (
                  <>
                    <div
                      className={`form-input-group ${viewStyles.radioLabel}`}
                    >
                      <label
                        htmlFor="lc_validity_period"
                        className={`form-label`}
                      >
                        LC Validity Period in Days
                      </label>
                    </div>
                    <div className={viewStyles.radioValue}>
                      <label
                        htmlFor="lc_validity_period"
                        className={`form-label`}
                      >
                        <input
                          type="radio"
                          name="lc_validity_period"
                          value="30"
                          checked={formData.lc_validity_period === "30"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      30
                      <label
                        htmlFor="lc_validity_period"
                        className={`form-label`}
                        style={{ marginLeft: "20px" }}
                      >
                        <input
                          type="radio"
                          name="lc_validity_period"
                          value="60"
                          checked={formData.lc_validity_period === "60"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      60
                      <label
                        htmlFor="lc_validity_period"
                        className={`form-label`}
                        style={{ marginLeft: "20px" }}
                      >
                        <input
                          type="radio"
                          name="lc_validity_period"
                          value="90"
                          checked={formData.lc_validity_period === "90"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      90
                    </div>
                  </>
                )}
              </div>
            </div>
            {errorMessages.lc_validity_period && (
              <p className={`text-danger`} style={{ marginTop: "5px" }}>
                {errorMessages.lc_validity_period}
              </p>
            )}
            <div className={`form-input-row ${viewStyles.radioRow}`}>
              <div className={`form-input-col md-col`}>
                {isInvoiceLoading ? (
                  <Skeleton />
                ) : (
                  <>
                    <div
                      className={`form-input-group ${viewStyles.radioLabel}`}
                    >
                      <label
                        htmlFor="total_price_type"
                        className={`form-label`}
                      >
                        Transhipment
                      </label>
                    </div>
                    <div className={viewStyles.radioValue}>
                      <label htmlFor="transhipment" className={`form-label`}>
                        <input
                          type="radio"
                          name="transhipment"
                          value="Allowed"
                          checked={formData.transhipment === "Allowed"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      Allowed
                      <label
                        htmlFor="transhipment"
                        className={`form-label`}
                        style={{ marginLeft: "20px" }}
                      >
                        <input
                          type="radio"
                          name="transhipment"
                          value="Not Allowed"
                          checked={formData.transhipment === "Not Allowed"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      Not Allowed
                    </div>
                  </>
                )}
              </div>
              <div className={`form-input-col md-col`}>
                {isInvoiceLoading ? (
                  <Skeleton />
                ) : (
                  <>
                    <div
                      className={`form-input-group ${viewStyles.radioLabel}`}
                    >
                      <label
                        htmlFor="total_price_type"
                        className={`form-label`}
                      >
                        Partial Shipment
                      </label>
                    </div>
                    <div className={viewStyles.radioValue}>
                      <label
                        htmlFor="partial_shipment"
                        className={`form-label`}
                      >
                        <input
                          type="radio"
                          name="partial_shipment"
                          value="Allowed"
                          checked={formData.partial_shipment === "Allowed"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      Allowed
                      <label
                        htmlFor="partial_shipment"
                        className={`form-label`}
                        style={{ marginLeft: "20px" }}
                      >
                        <input
                          type="radio"
                          name="partial_shipment"
                          value="Not Allowed"
                          checked={formData.partial_shipment === "Not Allowed"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      Not Allowed
                    </div>
                  </>
                )}
              </div>
            </div>
            {errorMessages.partial_shipment && (
              <p className={`text-danger`} style={{ marginTop: "5px" }}>
                {errorMessages.partial_shipment}
              </p>
            )}
            <div className={`form-input-row ${viewStyles.radioRow}`}>
              <div className={`form-input-col md-col`}>
                {isInvoiceLoading ? (
                  <Skeleton />
                ) : (
                  <>
                    <div
                      className={`form-input-group ${viewStyles.radioLabel}`}
                    >
                      <label
                        htmlFor="total_price_type"
                        className={`form-label`}
                      >
                        Total Price Type
                      </label>
                    </div>
                    <div className={viewStyles.radioValue}>
                      <label
                        htmlFor="total_price_type"
                        className={`form-label`}
                      >
                        <input
                          type="radio"
                          name="total_price_type"
                          value="CNF"
                          checked={formData.total_price_type === "CNF"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      CNF
                      <label
                        htmlFor="total_price_type"
                        className={`form-label`}
                        style={{ marginLeft: "20px" }}
                      >
                        <input
                          type="radio"
                          name="total_price_type"
                          value="FOB"
                          checked={formData.total_price_type === "FOB"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      FOB
                    </div>
                  </>
                )}
              </div>
              <div className={`form-input-col md-col`}>
                {isInvoiceLoading ? (
                  <Skeleton />
                ) : (
                  <>
                    <div
                      className={`form-input-group ${viewStyles.radioLabel}`}
                    >
                      <label htmlFor="invoice_type" className={`form-label`}>
                        Invoice Type
                      </label>
                    </div>
                    <div className={viewStyles.radioValue}>
                      <label htmlFor="invoice_type" className={`form-label`}>
                        <input
                          type="radio"
                          name="invoice_type"
                          value="Performa"
                          checked={formData.invoice_type === "Performa"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      Proforma
                      <label
                        htmlFor="invoice_type"
                        className={`form-label`}
                        style={{ marginLeft: "20px" }}
                      >
                        <input
                          type="radio"
                          name="invoice_type"
                          value="Commercial"
                          checked={formData.invoice_type === "Commercial"}
                          onChange={handleInputChange}
                          className={viewStyles.customRadio}
                        />
                      </label>
                      Commercial
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className={`form-input-row ${viewStyles.radioRow}`}>
              <div className={`form-input-col md-col`}>
                {isBankAccountsLoading ? (
                  <Skeleton />
                ) : (
                  <>
                    <div
                      className={`form-input-group ${viewStyles.radioLabel}`}
                    >
                      <label htmlFor="invoice_type" className={`form-label`}>
                        Bank
                      </label>
                    </div>
                    <div className={viewStyles.methodCards}>
                      {bankAccounts?.map((account) => (
                        <div
                          key={account.id}
                          className={viewStyles.methodCard}
                          onClick={() => {
                            setFormData({
                              ...formData,
                              bank_account_id: account.id,
                            });
                            setSelectedBank(account);
                          }}
                          style={{
                            border:
                              selectedBank?.id === account.id
                                ? "2px solid #E11F39"
                                : "2px solid #D1D5DB",
                            color:
                              selectedBank?.id === account.id
                                ? "white"
                                : "black",
                          }}
                        >
                          <img
                            src={account.image_url}
                            alt="BankAccount"
                            className={viewStyles.icon}
                          />
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
            {errorMessages.invoice_type && (
              <p className={`text-danger`} style={{ marginTop: "5px" }}>
                {errorMessages.invoice_type}
              </p>
            )}
            {isInvoiceLoading ? (
              <Skeleton />
            ) : (
              <button
                className={`btn-primary`}
                type="button"
                disabled={isInvoiceCreating}
                onClick={submitQuotation}
                style={{ marginTop: "20px" }}
              >
                {isInvoiceCreating ? <BeatLoader /> : `Save Invoice`}
              </button>
            )}
          </div>
        </div>
        <PDFViewer width="100%" height="800px" style={{ marginTop: "20px" }}>
          <EditQuickInvoicePdf
            data={[
              formData,
              vehicles,
              selectedBank,
              details,
              isNotifyParty,
              qrLink,
            ]}
          />
        </PDFViewer>
      </div>
    </div>
  );
};

export default EditQuickInvoice;
